import {
    StateApiData,
    StateApiResponse,
} from '@/core/domain/states/models/State.model';
import { StateRepository } from '@/core/domain/states/repositories/state.repository';
import { environment } from '@/env/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StateImplRepository extends StateRepository {
    constructor(private readonly http: HttpClient) {
        super();
    }

    override getStates(
        countryCode: string | null,
        language: string,
    ): Observable<StateApiData> {
        const _headers = new HttpHeaders({
            'X-Channel': 'web',
            'X-Api-Key': environment.vivaApi.API_KEY,
        });

        const _params = new HttpParams()
            .set('countryCode', countryCode || '')
            .set('language', language);

        return this.http
            .get<StateApiResponse>(
                environment.vivaApi.BASE_HOST +
                    environment.vivaApi.ENDPOINTS.provinces,
                { headers: _headers, params: _params },
            )
            .pipe(map((response) => response.data));
    }
}
